import * as CartService from '../services/CartService'

export const ADD_PARTICIPANT_TO_ITEM_REQUEST = 'ADD_PARTICIPANT_TO_ITEM_REQUEST';
export const ADD_PARTICIPANT_TO_ITEM_SUCCESS = 'ADD_PARTICIPANT_TO_ITEM_SUCCESS';
export const ADD_PARTICIPANT_TO_ITEM_FAILURE = 'ADD_PARTICIPANT_TO_ITEM_FAILURE';

export function addParticipantToItemRequest(participant, identifier) {
    return {
        type: ADD_PARTICIPANT_TO_ITEM_REQUEST,
        participant,
        identifier
    }
}

export function addParticipantToItemSuccess(payload) {
    return {
        type: ADD_PARTICIPANT_TO_ITEM_SUCCESS,
        payload
    }
}

export function addParticipantToItemFailure(payload) {
    return {
        type: ADD_PARTICIPANT_TO_ITEM_FAILURE,
        payload
    }
}

export function addParticipantToItem(participant, identifier) {
    return (dispatch) => {
        dispatch(addParticipantToItemRequest(participant, identifier));

        CartService.addParticipantToItem(participant, identifier)
            .then(response => {
                dispatch(addParticipantToItemSuccess(response));
            })
            .catch(error => {
                dispatch(addParticipantToItemFailure(error));
            });
    }
}
